import { ScrollHero } from "@/components/home/ScrollHero";
import { Seo } from "@/components/Seo";

/**
 * Internal preview of the Terminal-style scroll-driven hero (see ScrollHero).
 * Not linked in nav - reachable at /preview/hero so the live Home hero stays
 * untouched while we evaluate the new treatment. The block below the hero
 * exists only to show the pin releasing into normal page flow.
 */
export default function HeroPreview() {
  return (
    <>
      <Seo title="Hero preview" description="Scroll-driven hero preview." noindex />
      <ScrollHero />

      <section className="relative bg-brand-800 py-28 text-white">
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.07]"
          style={{
            backgroundImage:
              "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
            backgroundSize: "56px 56px",
          }}
        />
        <div className="relative mx-auto max-w-[1280px] px-6">
          <p className="text-sm font-medium uppercase tracking-[0.3em] text-accent-400">Next section</p>
          <h2 className="mt-4 max-w-3xl text-4xl font-bold leading-tight tracking-tight">
            This block only exists to show the hero un-pinning and the page scrolling normally below it.
          </h2>
          <p className="mt-6 max-w-2xl text-lg text-brand-100">
            Scroll back up to replay the build. On the real Home page this would be the positioning band,
            services, coverage map, etc.
          </p>
        </div>
      </section>
    </>
  );
}
